import { HudChip } from './HudChip';
import { HudHint } from './HudHint';
import { HudScrubber } from './HudScrubber';

interface RunPlaybackControlsProps {
  isPlaying: boolean;
  progress: number;
  boundArrowCount: number;
  onPlayPause: () => void;
  onStop: () => void;
  onScrub: (next: number) => void;
}

/**
 * Composite of Play/Pause + Stop + scrubber + run-count hint. Identical
 * markup in both tactics boards — used to live twice with subtle drift;
 * now a single source.
 */
export function RunPlaybackControls({
  isPlaying,
  progress,
  boundArrowCount,
  onPlayPause,
  onStop,
  onScrub,
}: RunPlaybackControlsProps) {
  return (
    <>
      <HudChip
        active={isPlaying}
        ariaLabel={isPlaying ? 'Pause runs' : 'Play runs'}
        onClick={onPlayPause}
      >
        {isPlaying ? '❚❚ Pause' : '▶ Play'}
      </HudChip>
      <HudChip ariaLabel="Stop and reset runs" onClick={onStop}>
        {'◼'} Stop
      </HudChip>
      <HudScrubber value={progress} onChange={onScrub} ariaLabel="Run playback progress" />
      <HudHint>
        {boundArrowCount} run{boundArrowCount === 1 ? '' : 's'}
      </HudHint>
    </>
  );
}
